import { useEffect, useState } from "react";
import { enqueueSnackbar } from "../../../../components/GlobalSnackbar/snackbarStore";
import useGetProviderById from "../../api/useGetProviderById";
import { useGetProviders } from "../../api/useGetProviders";
import usePostProvider from "../../api/usePostProvider";

export function useProviderAutocomplete(
  value: string | null,
  onChange: (value: string | null) => void,
  defaultSearch?: string | null
) {
  const [inputValue, setInputValue] = useState(defaultSearch || "");
  const { data: suggestedProviders, isLoading: isLoadingSuggestions } = useGetProviders(
    {
      search: inputValue,
      page: 1,
      limit: 10,
    },
    {
      enabled: inputValue.length > 0,
    }
  );
  const { data: selectedProvider, isLoading: isLoadingSelected } = useGetProviderById(value || undefined);
  const { mutateAsync: postProvider, isPending: isPosting } = usePostProvider();

  useEffect(() => {
    if (defaultSearch !== undefined) {
      setInputValue(defaultSearch || "");
    }
  }, [defaultSearch]);

  useEffect(() => {
    if (selectedProvider?.name && !inputValue) {
      setInputValue(selectedProvider.name);
    }
  }, [selectedProvider?.name]);

  const options = suggestedProviders ? [...suggestedProviders] : [];
  if (selectedProvider && !options.find(p => p.id === selectedProvider.id)) {
    options.push(selectedProvider);
  }

  const isLoading = isLoadingSuggestions || (!!value && isLoadingSelected) || isPosting;

  async function handleCreateProvider() {
    if (!inputValue.trim()) return;
    try {
      const result = await postProvider({ command: { name: inputValue } });
      onChange(result.id);
      enqueueSnackbar(`Le prestataire "${inputValue}" a bien été créé.`, 'success');
    } catch {
      enqueueSnackbar(`Une erreur est survenue lors de la création du prestataire "${inputValue}".`, 'error');
    }
  }

  return {
    options,
    selectedProvider,
    isLoading,
    inputValue,
    setInputValue,
    handleCreateProvider,
    isPosting,
  };
}

